import { render } from "./profileSettings.vue?vue&type=template&id=5622d337&scoped=true"
import script from "./profileSettings.js?vue&type=script&lang=js"
export * from "./profileSettings.js?vue&type=script&lang=js"

import "./profileSettings.vue?vue&type=style&index=0&id=5622d337&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5622d337"]])

export default __exports__